import React from "react";
import { Badge, ActionIcon, Avatar } from "rizzui";
import ProfileMenu from "./profileMenu";
import { ThemeSwitcher } from "../../component/themeSwitch";
import RightButton from "./rightButton";

export default function HeaderMenuRight() {
  return (
    <div className="ms-auto grid shrink-0 grid-cols-2 items-center gap-2 text-gray-700 xs:gap-3 xl:gap-4">
      <ThemeSwitcher />
      <ProfileMenu />
    </div>
  );
}
